import React from "react";
import { useMutation } from "react-query";
import { getInvoiceBy } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useSearchReconcilliation = () => {
  return useMutation(getInvoiceBy);
};

export default useSearchReconcilliation;
